// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3gvyA","inner":"Footer_inner__2atYW"};